var _rect, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgBg5(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 1440,
    height: 460,
    viewBox: "0 0 1440 460",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_5765_67416",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 1444,
    height: 460
  }, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 1444,
    height: 460,
    fill: "#E9F4EF"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_5765_67416)"
  }, /*#__PURE__*/React.createElement("rect", {
    opacity: 0.4,
    x: -49.7168,
    y: -101,
    width: 638.002,
    height: 584.472,
    rx: 50,
    transform: "rotate(45 -49.7168 -101)",
    fill: "#8AD29B"
  }), /*#__PURE__*/React.createElement("rect", {
    x: -183.717,
    y: -96,
    width: 638.002,
    height: 584.472,
    rx: 50,
    transform: "rotate(45 -183.717 -96)",
    fill: "#A3DAB0"
  }), /*#__PURE__*/React.createElement("rect", {
    opacity: 0.1,
    x: 1455.36,
    y: -150.929,
    width: 125.311,
    height: 584.472,
    rx: 50,
    transform: "rotate(45 1455.36 -150.929)",
    fill: "#52C188"
  }), /*#__PURE__*/React.createElement("rect", {
    opacity: 0.14,
    x: 1678.28,
    y: -147,
    width: 137.698,
    height: 584.472,
    rx: 50,
    transform: "rotate(45 1678.28 -147)",
    fill: "#22B343"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgBg5);
export default __webpack_public_path__ + "static/media/bg-5.4b4d82e8a6ccc387ee70e445151200b9.svg";
export { ForwardRef as ReactComponent };